<template>
  <div class="ch-component-warpper">
    <div class="ch-component">
      <button
        class="ch-floating-btn ch-menu-btn"
        @click="openDialog"
      >
        <span><i class="far fa-plus-square fa-fw"></i></span>
        DOMAIN
      </button>
      <v-container fluid grid-list-lg class="ch-menu-wrapper">
        <div class="ch-menu-title">
          <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
            <span class="ch-menu-btn-icon" v-show="navigationDrawer">
              <i class="fas fa-minus fa-fw"></i>
            </span>
            <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
              <i class="fas fa-plus fa-fw"></i>
            </span>
          </button> -->
          <span class="ch-component-title pl-2">DOMAIN</span>
        </div>
        <div class="filter-body-wrapper">
          <domains-filter :storeFilter="storeFilter"></domains-filter>
        </div>
      </v-container>
      <v-container fluid grid-list-lg class="pt-4">
        <DomainsList :storeFilter="storeFilter" :storePage="storePage"></DomainsList>
      </v-container>
      <create-Domain></create-Domain>
      <scroll-event></scroll-event>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import { domainsEventBus } from '@/components/admin/domains/domainsEventBus';
  import DomainsFilter from '@/components/admin/domains/DomainsFilter';
  import DomainsList from '@/components/admin/domains/DomainsList';
  import CreateDomain from '@/components/admin/domains/CreateDomain';
  import ScrollEvent from '@/components/customized-components/ScrollEvent';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        navigationDrawer: true,
      };
    },
    methods: {
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
      openDialog() {
        domainsEventBus.$emit('openDialog');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      DomainsFilter, DomainsList, CreateDomain, ScrollEvent,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Domains.vue